/** Human-readable label for a Lichess-style time control and speed class. */
export function formatTimeControlLabel(
  timeControl?: string,
  timeClass?: string,
): string | null {
  const speed =
    timeClass && timeClass !== 'UNKNOWN'
      ? timeClass.charAt(0).toUpperCase() + timeClass.slice(1)
      : null;
  const clock = formatClockString(timeControl);

  if (speed && clock) {
    return `${speed} · ${clock}`;
  }
  return speed ?? clock;
}

function formatClockString(timeControl?: string): string | null {
  if (!timeControl || timeControl === 'UNKNOWN' || timeControl === '-') {
    return null;
  }
  if (timeControl.includes('/')) {
    return 'Correspondence';
  }

  const [baseStr, incStr = '0'] = timeControl.split('+');
  const base = Number.parseInt(baseStr ?? '', 10);
  const inc = Number.parseInt(incStr ?? '0', 10);
  if (!Number.isFinite(base)) {
    return timeControl;
  }

  const baseMinutes = base >= 60 ? Math.round(base / 60) : base;
  const baseUnit = base >= 60 ? 'min' : 's';
  if (inc > 0) {
    return base >= 60
      ? `${baseMinutes}+${inc}s`
      : `${baseMinutes}${baseUnit}+${inc}s`;
  }
  return base >= 60 ? `${baseMinutes}+0` : `${baseMinutes}${baseUnit}`;
}
